<template>
  <div v-if="foundItems !== undefined">
    <form class="a-sort" action="">
      <p class="a-sort__see">
        {{$tc('form.accreditation-search.search-result', foundItems)}}
      </p>
      <button class="gui-btn gui-btn--red gui-btn--w-140 u-margin-b-24" type="button" @click="exportAccreditationsList" v-t="'buttons.export'"></button>
    </form>
    <div class="a-сard-admin">
      <div class="a-сard-admin__block" v-for="acc in items">
        <div class="a-сard-admin__body">
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.username')}}:</div>
            <p class="a-сard-admin__text">{{acc.lastName}} {{acc.firstName}} {{acc.middleName}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.organization-type')}}:</div>
            <p class="a-сard-admin__text">{{$t(acc.organizationType.label)}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.organization-title')}}:</div>
            <p class="a-сard-admin__text">{{acc.fullName}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.accreditation-search.accreditation-request-type.label')}}:</div>
            <p class="a-сard-admin__text">{{$t(acc.type.label)}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('labels.status')}}:</div>
            <p class="a-сard-admin__text">{{$t(acc.state.label)}}</p>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.accreditation-search.submission-date.label')}}:</div>
            <date-time class="a-сard-admin__text" :value="acc.start" :time="false"></date-time>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.accreditation-search.resolution-date.label')}}:</div>
            <date-time class="a-сard-admin__text" :value="acc.resolution" :time="false"></date-time>
          </div>
          <div class="a-сard-admin__content-text">
            <div class="a-сard-admin__label">{{$t('form.accreditation-search.expiry-date.label')}}:</div>
            <date-time class="a-сard-admin__text" :value="acc.expired" :time="false"></date-time>
          </div>
        </div>
          <router-link class="gui-btn gui-btn--red gui-btn--large-red-a"
                       :to="{name: 'admin-accreditations-account', params: { userId: acc.owner, tab: acc.type.ACCREDITATION ? 'accreditation': 'signatures'}}"
                       v-t="'buttons.open-profile'">
          </router-link>
      </div>

      <button class="gui-btn gui-btn--more u-margin-24-auto"
              type="button"
              @click="fetchMoreAccreditations"
              v-if="foundItems !== items.length">
        {{$t('buttons.show-more')}}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      foundItems() { return this.$store.state.search.accreditations.total },
      items() { return this.$store.state.search.accreditations.items }
    },
    methods: {
      exportAccreditationsList() {
        this.$store.dispatch('exportAccreditationsList');
      },

      fetchMoreAccreditations() {
        this.$store.dispatch('fetchMoreAccreditations');
      }
    }
  }
</script>

<style scoped>

</style>
